import { Component, Prop, Vue } from 'vue-property-decorator';
import Quantity  from './quantity.vue';

@Component({
  components: {
    Quantity
  }
})
export default class ProductItem extends Vue {
  @Prop({type: Boolean, default: false})
  isLoading: boolean;

  @Prop({type: Array, default: []})
  invoiceItems: any;

  @Prop({type: Boolean, default: false})
  readOnly: boolean;

  public qtyDialog = false;
  public hasError = false;
  public editedIndex: -1;
  public editedQty = {};
  public additionalQty = 0;
  public learnerList = [];

  public headers = [
    { text: 'Name', value: 'productName', sortable: false, width: '37%' },
    { text: 'Qty', value: 'quantity', sortable: false, width: '25%' },
    { text: 'Total', value: 'computedAmountPerPeriod', sortable: false, width: '33%' },
    { text: '', value: 'actions', sortable: false, width: '5%'}
  ];

  public mounted(): void {
  }

  public getTextColor(item) {
    return item.deleted ? 'font-weight-bold text--disabled' : 'font-weight-bold';
  }

  public get totalRows() {
    return this.invoiceItems.length > 0 ?  this.invoiceItems.length : 1;
  }

  public get skeletonType() {
    if (this.totalRows ==  1) {
      return 'list-item';
    }

    let val = '';
    for (let i = 0; i < this.totalRows; i++) {
      val += 'list-item,divider,';
    }
    // remove the last comma and divider which equals 9 characters
    val = val.substring(0, val.length - 9);
    return val;
  }

  public get skeletonHeight() {
    if (this.totalRows > 0) {
      return this.totalRows * 50;
    }

    return 50;
  }

  public toLearner(learner) {
    this.qtyDialog = false;

    this.$emit('toLearner', learner, this.editedIndex, this.editedQty);
    this.editQty(learner);
  }


  public editQty(item) {
    this.editedIndex = this.invoiceItems.indexOf(item);
    this.editedQty = Object.assign({}, item);
    if (item.relatedAuthor) {
      this.additionalQty = Number(item.relatedAuthor.quantity);
    } else {
      this.additionalQty = 0;
    }
    this.qtyDialog = true;
  }


  public updateError(error) {
    this.hasError = error ? true : false;
  }


  public isSilver(item) {
    return item.productName.includes('Silver');
  }

  public removeProduct(item) {
    this.$emit('planRemoved', item);
  }

  public close() {
    this.qtyDialog = false;
    this.$nextTick(() => {
      this.editedQty = Object.assign({}, {});
      this.editedIndex = -1;
    });
  }

  public quantityChange(item) {
    this.$emit('quantityChange', item, this.additionalQty);
  }

  public updateItemQty() {
    if (this.editedIndex > -1) {

      Object.assign(this.invoiceItems[this.editedIndex], this.editedQty);
      this.quantityChange(this.invoiceItems[this.editedIndex]);
    }
    this.close();
  }

  public updateQty(qty, additionalAuthors) {
    if (this.editedQty && this.editedQty['quantity']) {
      this.editedQty['quantity'] = qty;
    }

    if (this.editedQty && this.editedQty['relatedAuthor'] ) {
      this.editedQty['relatedAuthor']['quantity'] = Number(additionalAuthors);
    }

    this.additionalQty = Number(additionalAuthors);
  }

  public restoreProduct(item) {
    this.$emit('planRestored', item);
  }

}
